// src/components/HavloController.jsx
// Bridges the app's auth state to the embedded Havlo chat widget.
//
// - Logged-out visitors keep the floating Havlo launcher bubble (no sidebar).
// - Signed-in users get the launcher HIDDEN; they open chat from the sidebar
//   ("Live Chat" under Dashboard) which calls window.HavloWidget.open().
// - Signed-in users are identified to Havlo (name, email, uid) so the Havlo
//   inbox and visitor list show who they are. Cleared again on logout.
//
// The widget loads asynchronously from havlo-widget.web.app, so we poll briefly
// until window.HavloWidget is available, then apply (and re-apply on auth change).

import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";

export default function HavloController() {
  const { currentUser, client } = useAuth();
  const name = currentUser ? currentUser.displayName || client?.name || currentUser.email || "" : null;

  useEffect(() => {
    const apply = () => {
      const w = window.HavloWidget;
      if (!w || typeof w.hideLauncher !== "function") return false;
      // The in-site chat (LiveChatWidget) is the chat for everyone again (Nov 3 2026),
      // so the Havlo launcher stays hidden.
      w.hideLauncher();
      if (typeof w.identify === "function") {
        w.identify(currentUser ? { name, email: currentUser.email || "", userId: currentUser.uid } : null);
      }
      return true;
    };

    if (apply()) return undefined;

    let tries = 0;
    const id = setInterval(() => {
      tries += 1;
      if (apply() || tries > 40) clearInterval(id); // up to ~20s for the widget to load
    }, 500);
    return () => clearInterval(id);
  }, [currentUser, name]);

  return null;
}
